import React, { PureComponent } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 0, 1);
`

class Setup extends PureComponent {
	render() {
		return <Wrapper />
	}
}

export default Setup
